import register from '@kpsys/angularjs-register';
import {KpFooterService} from 'shared/components/kp-footer/kp-footer.service';

/**
 * @ngdoc module
 * @name portaro.shared.footer
 * @module portaro.shared.footer
 */
export default register('portaro.shared.footer')
    .service(KpFooterService.serviceName, KpFooterService)
    .name();